var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnsubscribe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_2379)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_212_2379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 130,
    height: 129
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.705 124.705H51.6157V120.395H118.255C118.823 120.395 119.367 120.169 119.768 119.768C120.169 119.367 120.395 118.823 120.395 118.255V30.1577C120.394 29.6213 120.192 29.1048 119.828 28.7104L105.308 12.9787H124.705V124.705ZM30.1104 111.192C35.3795 112.157 40.7963 111.951 45.9773 110.591C51.1583 109.23 55.9768 106.747 60.0916 103.317C64.2064 99.8873 67.5169 95.5949 69.7887 90.7438C72.0606 85.8927 73.2382 80.6015 73.2382 75.2448C73.2382 69.8881 72.0606 64.5969 69.7887 59.7458C67.5169 54.8947 64.2064 50.6023 60.0916 47.1726C55.9768 43.7429 51.1583 41.2598 45.9773 39.8989C40.7963 38.5381 35.3795 38.3329 30.1104 39.2978V4.29479H90.3V30.0948C90.3 30.3778 90.3557 30.6581 90.464 30.9196C90.5723 31.181 90.7311 31.4186 90.9312 31.6188C91.1313 31.8189 91.3689 31.9777 91.6304 32.086C91.8919 32.1943 92.1722 32.25 92.4552 32.25H116.053V116.1H30.1104V111.192ZM4.31044 75.2448C4.31358 67.7838 6.90358 60.5546 11.6391 54.7891C16.3747 49.0235 22.9629 45.0783 30.2811 43.6256C37.5993 42.1729 45.1949 43.3025 51.7736 46.8221C58.3524 50.3417 63.5072 56.0334 66.36 62.9275C69.2127 69.8216 69.5868 77.4916 67.4185 84.6306C65.2503 91.7697 60.6738 97.936 54.4688 102.079C48.2638 106.222 40.8142 108.086 33.3894 107.352C25.9645 106.618 19.0236 103.333 13.7495 98.0558C10.7552 95.0597 8.38046 91.5032 6.7609 87.5892C5.14133 83.6752 4.30866 79.4806 4.31044 75.2448ZM94.6104 7.59845L113.347 27.9553H94.6104V7.59845ZM126.845 8.55808H101.328L94.0126 0.692226C93.8137 0.472822 93.5709 0.297785 93.2998 0.17852C93.0287 0.0592549 92.7356 -0.00156256 92.4395 3.05061e-05H27.9395C27.6572 2.28748e-05 27.3777 0.05588 27.1171 0.164383C26.8565 0.272886 26.6199 0.431889 26.421 0.632231C26.2221 0.832572 26.0649 1.07029 25.9583 1.33169C25.8517 1.59308 25.7979 1.87299 25.8 2.15527V40.3204C18.3275 42.6169 11.7884 47.2491 7.14308 53.5365C2.49773 59.8239 -0.0090332 67.4353 -0.0090332 75.2527C-0.0090332 83.07 2.49773 90.6814 7.14308 96.9688C11.7884 103.256 18.3275 107.888 25.8 110.185V118.255C25.8 118.823 26.0254 119.367 26.4266 119.768C26.8278 120.169 27.372 120.395 27.9395 120.395H47.2895V126.845C47.2895 127.129 47.3457 127.411 47.455 127.673C47.5643 127.936 47.7245 128.174 47.9263 128.374C48.1281 128.575 48.3675 128.733 48.6308 128.841C48.8941 128.948 49.1761 129.002 49.4604 129H126.845C127.128 129 127.408 128.944 127.669 128.836C127.931 128.728 128.169 128.569 128.369 128.369C128.569 128.169 128.728 127.931 128.836 127.67C128.944 127.408 129 127.128 129 126.845V10.7448C129 10.4625 128.944 10.183 128.836 9.92238C128.727 9.66177 128.568 9.42521 128.368 9.22633C128.167 9.02746 127.93 8.87019 127.668 8.7636C127.407 8.65701 127.127 8.6032 126.845 8.60527V8.55808Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_212_2379)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_212_2379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1053,
    y: -568,
    width: 2266,
    height: 5087
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.91 -567.978H-1052.45V4518.08H1212.91V-567.978Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_212_2379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.573 -1.57324H-1.57324V130.573H130.573V-1.57324Z",
    fill: "#E72064"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_212_2379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 11,
    width: 13,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9147 11.0122H39.3293V15.7317H51.9147V11.0122Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_212_2379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4878 9.43896H37.7561V17.3048H53.4878V9.43896Z",
    fill: "#E72064"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_212_2379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 11,
    width: 26,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.378 11.0122H58.2073V15.7317H83.378V11.0122Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_212_2379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9511 9.43896H56.634V17.3048H84.9511V9.43896Z",
    fill: "#E72064"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_212_2379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 20,
    width: 46,
    height: 6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9513 20.4512H39.3293V25.1707H84.9513V20.4512Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_212_2379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5244 18.8779H37.7561V26.7438H86.5244V18.8779Z",
    fill: "#E72064"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_212_2379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 51,
    width: 48,
    height: 49
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9279 93.8711L17.8083 87.7672L28.5216 77.0853C28.7242 76.8862 28.8851 76.6487 28.995 76.3867C29.1048 76.1247 29.1614 75.8434 29.1614 75.5593C29.1614 75.2752 29.1048 74.994 28.995 74.732C28.8851 74.47 28.7242 74.2325 28.5216 74.0334L17.8083 63.3044L23.9279 57.1847L34.6097 67.8665C35.0161 68.2681 35.5644 68.4933 36.1357 68.4933C36.707 68.4933 37.2553 68.2681 37.6617 67.8665L48.3907 57.1533L54.5103 63.2572L43.8442 73.939C43.4379 74.346 43.2096 74.8977 43.2096 75.4728C43.2096 76.048 43.4379 76.5996 43.8442 77.0067L54.5575 87.72L48.4379 93.8396L37.7561 83.1578C37.5569 82.9551 37.3194 82.7942 37.0574 82.6843C36.7954 82.5745 36.5142 82.5179 36.2301 82.5179C35.946 82.5179 35.6647 82.5745 35.4027 82.6843C35.1407 82.7942 34.9032 82.9551 34.7041 83.1578L23.9279 93.8711ZM46.8962 98.4804C47.1001 98.6917 47.3445 98.8597 47.6148 98.9745C47.8851 99.0892 48.1757 99.1483 48.4694 99.1483C48.763 99.1483 49.0536 99.0892 49.3239 98.9745C49.5942 98.8597 49.8386 98.6917 50.0425 98.4804L59.2299 89.2931C59.6324 88.8841 59.858 88.3332 59.858 87.7593C59.858 87.1854 59.6324 86.6345 59.2299 86.2255L48.4379 75.5122L59.1512 64.7989C59.5528 64.3925 59.778 63.8442 59.778 63.2729C59.778 62.7016 59.5528 62.1533 59.1512 61.7469L49.9639 52.5596C49.7599 52.3483 49.5155 52.1803 49.2452 52.0656C48.975 51.9508 48.6843 51.8917 48.3907 51.8917C48.0971 51.8917 47.8064 51.9508 47.5362 52.0656C47.2659 52.1803 47.0215 52.3483 46.8175 52.5596L36.1829 63.2572L25.4696 52.5439C25.2657 52.3326 25.0213 52.1646 24.751 52.0499C24.4807 51.9351 24.1901 51.876 23.8964 51.876C23.6028 51.876 23.3122 51.9351 23.0419 52.0499C22.7716 52.1646 22.5272 52.3326 22.3233 52.5439L13.2146 61.7469C12.813 62.1533 12.5878 62.7016 12.5878 63.2729C12.5878 63.8442 12.813 64.3925 13.2146 64.7989L23.9279 75.5122L13.2146 86.2255C12.812 86.6345 12.5864 87.1854 12.5864 87.7593C12.5864 88.3332 12.812 88.8841 13.2146 89.2931L22.4019 98.4804C22.6059 98.6917 22.8503 98.8597 23.1206 98.9745C23.3908 99.0892 23.6815 99.1483 23.9751 99.1483C24.2687 99.1483 24.5593 99.0892 24.8296 98.9745C25.0999 98.8597 25.3443 98.6917 25.5483 98.4804L36.1829 87.7672L46.8962 98.4804Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_212_2379)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_212_2379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1053,
    y: -568,
    width: 2266,
    height: 5087
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.91 -567.978H-1052.45V4518.08H1212.91V-567.978Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_212_2379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5738 50.1367H10.8076V100.903H61.5738V50.1367Z",
    fill: "#E72064"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_2379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 129,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribe);
export default __webpack_public_path__ + "static/media/unsubscribe.9dc20adb6499803570402aa65e248198.svg";
export { ForwardRef as ReactComponent };